var map = {
	"./colors.dark": [
		364,
		420
	],
	"./colors.dark.json": [
		364,
		420
	],
	"./colors.light": [
		365,
		421
	],
	"./colors.light.json": [
		365,
		421
	],
	"./theme": [
		5,
		36
	],
	"./theme.json": [
		5,
		36
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 407;
module.exports = webpackAsyncContext;